module.exports = __webpack_public_path__ + "img/Prima Master Bank.e32ce5e7.png";